import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

export const managerGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isManager || auth.isAdmin) return true;
  router.navigate(['/public-schedule']);
  return false;
};
